import { render, staticRenderFns } from "./Seat.vue?vue&type=template&id=0bd7f558&scoped=true&"
import script from "./Seat.vue?vue&type=script&lang=js&"
export * from "./Seat.vue?vue&type=script&lang=js&"
import style0 from "./Seat.vue?vue&type=style&index=0&id=0bd7f558&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd7f558",
  null
  
)

export default component.exports